import React from "react";
import { Container, Jumbotron } from "react-bootstrap";

export default ({ bg = "white", text = "dark", children, className }) => (
  <Jumbotron className={`rounded-0 mb-0 bg-${bg} text-${text} ${className}`}>
    <Container>{children}</Container>
  </Jumbotron>
);
